<template>
	<div class="col-lg-6">
		<div class="reg-wrapper">
			<h2 class="account-h2 u-s-m-b-20">Register</h2>
			<h6 class="account-h6 u-s-m-b-30">
				{{ status.register_meta_data.metadata.status }}
				Registering for this site allows you to access your order status and history.
			</h6>
			<form @submit.prevent="handleSubmit">
				<div class="u-s-m-b-30">
					<label for="user-name"
						>Username
						<span class="astk">*</span>
					</label>
					<input
						type="text"
						id="user-name"
						class="text-field"
						placeholder="Username"
						v-model="username"
						required
					/>
				</div>
				<div class="u-s-m-b-30">
					<label for="email"
						>Email
						<span class="astk">*</span>
					</label>
					<input
						type="email"
						id="email"
						class="text-field"
						placeholder="Email"
						v-model="email"
						required
					/>
					<h6
						class="account-h6 u-s-m-b-30 mt-1"
						style="color: red"
						v-if="status.register.error.email"
					>
						{{ status.register.error.email[0] }}
					</h6>
				</div>
				<div class="u-s-m-b-30">
					<label for="phone_number"
						>Phone Number
						<span class="astk">*</span>
					</label>
					<input
						type="text"
						id="phone_number"
						class="text-field"
						placeholder="Phone Number"
						v-model="phone_number"
						required
						minlength="10"
						maxlength="10"
					/>
					<h6
						class="account-h6 u-s-m-b-30 mt-1"
						style="color: red"
						v-if="status.register.error.phone_no"
					>
						{{ status.register.error.phone_no[0] }}
					</h6>
				</div>
				<div class="u-s-m-b-30">
					<label for="password"
						>Password
						<span class="astk">*</span>
					</label>
					<input
						type="password"
						id="password"
						class="text-field"
						placeholder="Password"
						v-model="password"
						required
						autocomplete="off"
					/>
					<h6
						class="account-h6 u-s-m-b-30 mt-1"
						style="color: red"
						v-if="status.register.error.password"
					>
						{{ status.register.error.password[0] }}
					</h6>
				</div>
				<div class="u-s-m-b-30">
					<label for="login-password"
						>Confirm Password
						<span class="astk">*</span>
					</label>
					<input
						type="password"
						id="login-password-c"
						class="text-field"
						placeholder="Confirm Password"
						v-model="password_confirmation"
						required
						autocomplete="off"
					/>
				</div>
				<div
					class="u-s-m-b-30"
					v-if="
						status.register_meta_data.metadata.status == 'otp_sent' ||
						status.register_meta_data.metadata.status == 'error'
					"
				>
					<label for="login-password"
						>OTP
						<span class="astk">*</span>
					</label>
					<input
						type="text"
						id="otp"
						class="text-field"
						placeholder="OTP"
						v-model="otp"
						required
						autocomplete="off"
					/>
					<h6 class="account-h6 u-s-m-b-30 mt-1" style="color: red">
						{{ status.register_meta_data.metadata.message }}
					</h6>
				</div>
				<div class="u-s-m-b-30">
					<input type="checkbox" class="check-box" id="accept" v-model="tnc" value="1" />
					<label class="label-text no-color" for="accept"
						>I’ve read and accept the
						<router-link
							:to="{name: 'TermsAndConditions', query: {type: 'buyer'}}"
							class="u-c-brand"
							>terms & conditions</router-link
						>
					</label>
				</div>
				<div class="u-s-m-b-45">
					<button class="button button-primary w-100" :disabled="status.register.loading">
						{{ status.register.loading ? "Please Wait." : "Register" }}
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import {useToast} from "vue-toastification";
	import {mapActions, mapGetters} from "vuex";
	export default {
		computed: {...mapGetters("auth", ["status"])},
		methods: {
			...mapActions("auth", ["register"]),
			handleSubmit() {
				if (this.tnc) {
					this.register({
						name: this.username,
						email: this.email,
						phone_no: this.phone_number,
						password: this.password,
						password_confirmation: this.password_confirmation,
						otp: this.otp,
					});
				} else {
					useToast().error("Please accept the terms and conditions.", {
						timeout: 3000,
					});
				}
			},
		},
		data() {
			return {
				username: "",
				email: "",
				password: "",
				password_confirmation: "",
				phone_number: "",
				otp: "",
				tnc: false,
			};
		},
	};
</script>

<style></style>
